// src/components/PersonaModal.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';

const PersonaModal = ({ persona, onClose, isUnlocked = true }) => {
  if (!persona) return null;
  const { i18n } = useTranslation();
  const isZh = (i18n?.language || '').toLowerCase().startsWith('zh');
  const imgSrc = isZh && persona.imageZh ? persona.imageZh : persona.image;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm"
      onClick={onClose}
    >
      {/* 关闭按钮：在卡片外、右上角 */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 p-2 rounded-full bg-black/60 hover:bg-black/80 text-white shadow-lg transition-colors"
      >
        <X size={18} />
      </button>

      {/* 卡片本体：只放 PNG，适当放大 */}
      <div
        className="relative mx-4 max-w-2xl max-h-[80vh] w-auto rounded-3xl overflow-hidden shadow-2xl bg-black/10"
        onClick={(e) => e.stopPropagation()} // 防止点击图片关闭
      >
        <img
          src={imgSrc}
          alt={persona.englishName}
          className={`w-full h-full object-contain ${
            !isUnlocked ? 'opacity-60' : ''
          }`}
        />
      </div>
    </div>
  );
};

export default PersonaModal;
